import React from 'react'

export function SystemStatus() {
  const services = [
    { name: 'API Server', status: 'healthy', url: '/health' },
    { name: 'Database', status: 'healthy', response: '12ms' },
    { name: 'Keycloak Auth', status: 'healthy', response: '45ms' },
    { name: 'Redis Cache', status: 'healthy', response: '3ms' },
    { name: 'Stripe Payments', status: 'healthy', response: '120ms' },
  ]

  const metrics = [
    { label: 'Uptime', value: '99.9%', color: 'green' },
    { label: 'Response Time', value: '125ms', color: 'green' },
    { label: 'Error Rate', value: '0.01%', color: 'green' },
    { label: 'Active Users', value: '42', color: 'blue' },
  ]

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">System Status</h2>

      {/* System Health Overview */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        {metrics.map((metric) => (
          <div key={metric.label} className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="text-sm font-medium text-gray-600">{metric.label}</div>
            <div className={`text-2xl font-bold ${
              metric.color === 'green' ? 'text-green-600' :
              metric.color === 'blue' ? 'text-blue-600' : 'text-gray-900'
            }`}>
              {metric.value}
            </div>
          </div>
        ))}
      </div>

      {/* Service Status */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden mb-8">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Service Health</h3>
        </div>
        <div className="divide-y divide-gray-200">
          {services.map((service) => (
            <div key={service.name} className="px-6 py-4 flex items-center justify-between">
              <div className="flex items-center">
                <div className={`w-3 h-3 rounded-full mr-3 ${
                  service.status === 'healthy' ? 'bg-green-400' : 'bg-red-400'
                }`}></div>
                <span className="font-medium text-gray-900">{service.name}</span>
              </div>
              <div className="flex items-center space-x-4">
                {service.response && (
                  <span className="text-sm text-gray-500">{service.response}</span>
                )}
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  service.status === 'healthy'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800'
                }`}>
                  {service.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* System Information */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Environment Info</h3>
          <dl className="space-y-3">
            <div>
              <dt className="text-sm font-medium text-gray-500">Environment</dt>
              <dd className="text-sm text-gray-900">Production</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">API Version</dt>
              <dd className="text-sm text-gray-900">v1.0.0</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Build</dt>
              <dd className="text-sm text-gray-900">#12345</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Last Deployment</dt>
              <dd className="text-sm text-gray-900">2024-01-15 14:30 UTC</dd>
            </div>
          </dl>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Resource Usage</h3>
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-600">CPU Usage</span>
                <span className="font-medium">45%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div className="bg-blue-600 h-2 rounded-full" style={{ width: '45%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-600">Memory Usage</span>
                <span className="font-medium">62%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div className="bg-green-600 h-2 rounded-full" style={{ width: '62%' }}></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-600">Disk Usage</span>
                <span className="font-medium">28%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div className="bg-yellow-600 h-2 rounded-full" style={{ width: '28%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}